"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabeledCheckbox = void 0;
var theme_ui_1 = require("theme-ui");
var Checkbox_1 = require("../../atoms/Checkbox/Checkbox");
var LabeledCheckbox = function (_a) {
    var id = _a.id, _b = _a.lsx, lsx = _b === void 0 ? {} : _b, _c = _a.csx, csx = _c === void 0 ? {} : _c, label = _a.label, children = _a.children, restProps = __rest(_a, ["id", "lsx", "csx", "label", "children"]);
    return (theme_ui_1.jsx(theme_ui_1.Label, { htmlFor: id, sx: __assign({ display: "flex", m: 0, mr: 2, mb: 2 }, lsx) },
        theme_ui_1.jsx(Checkbox_1.Checkbox, __assign({ id: id, csx: __assign({}, csx) }, restProps)),
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: { alignItems: "center", minHeight: "28px" } },
            theme_ui_1.jsx(theme_ui_1.Text, { as: "span", variant: "text.small", sx: { my: "-0.5em" } }, label !== null && label !== void 0 ? label : children))));
};
exports.LabeledCheckbox = LabeledCheckbox;
